const e = (o) => Object.entries(o).filter(([, s]) => s).map(([s]) => s).join(" "), c = () => {
  document.body.classList.add("hide-icons"), document.fonts.addEventListener("loadingdone", t);
}, t = (o) => {
  const n = "Material Symbols Sharp";
  o.fontfaces.forEach((s) => {
    s.family === n && document.body.classList.remove("hide-icons");
  });
};
export {
  e as classNames,
  c as initIcons,
  t as onIconLoadComplete
};
